<!-- 해당 파일 수정시, PartnerLectureListView 파일도 함께 검토 후 수정 -->
<script setup>
    import { ref, watch, onMounted, getCurrentInstance } from 'vue'
    import { useRouter, RouterLink } from 'vue-router'
    import { storeToRefs } from "pinia";
    import { usePageLoadingStore } from "../../../../stores/pageLoading";
    import SNBAdmin from '../../../../layouts/nav/SNBAdmin.vue';
    import SNBPartAdmin from "../../../../layouts/nav/SNBPartAdmin.vue";
    import certificateTemplateService from "../../services/lecture/certificateTemplateService";
    import KSACertificateTemplatePreview from '../../../../components/ui-components/KSACertificateTemplatePreview.vue';
    import { useUserStore } from "../../../user/stores/user";
    import { useAlertStore } from "../../../../stores/alertStore";
    import _ from 'lodash'
    import moment from "moment";

    const { $alert, $confirm } = useAlertStore();
    const router = useRouter()
    const loadingStore = usePageLoadingStore()
    const userStore = useUserStore()
    const { isPartAdmin } = storeToRefs(userStore);
    const { $toast, $pageListBoardNo } = getCurrentInstance().appContext.config.globalProperties;

    onMounted(()=>{
        retrieveList();
    });

    const list = ref([])
    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalPages = ref(0);
    const totalCount = ref(0);

    const pageSizeGroup = ref([
        { label:"10개씩 보기", value: "10" },
        { label:"30개씩 보기", value: "30" },
        { label:"50개씩 보기", value: "50" },
        { label:"100개씩 보기", value: "100" },
    ]);

    const retrieveList = () => {
        const paramObj = {
            pageNo: currentPage.value,
            size: pageSize.value,
        };

        certificateTemplateService.retrieveAllPaging(paramObj)
            .then( async (res) => {
                loadingStore.loading = false;
                // console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
                }
            }).catch( (error) =>  {
                // console.log(error);
                loadingStore.loading = false;
            });
    };

    const onSelectPage = (pageNo) => {
        currentPage.value = pageNo;
        retrieveList();
    };

    const onSelectPageSize = (option) => {
        pageSize.value = option.value;
        currentPage.value = 1;
        retrieveList();
    };

    const onClickCreate = () => {
        router.push({name:'LectureCertificateTemplateCreate'});
    };

    const onClickDetail = (template) => {
        router.push({name:'LectureCertificateTemplateDetail', params: { id: template.templateId }});
    };
</script>
<template>
    <div class="content">
        <div class="sub-title">
            <h3>수료증 양식 관리</h3>
        </div>
        <!-- <div class="filter-wrap" :class="{'open': searchOpen}">
            <p @click="searchOpen = !searchOpen">검색</p>
            <div class="filter">
                <dl>
                    <dt>구분</dt>
                    <dd>
                        <template v-for="group in lectGbGroup" key="person.name" >
                            <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput.lectGb" :value="group.value" />
                        </template>
                    </dd>
                </dl>
                <dl>
                    <dt>상태</dt>
                    <dd>
                        <template v-for="group in lectOpenYnGroup" key="person.name" >
                            <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput.lectOpenYn" :value="group.value" />
                        </template>
                    </dd>
                </dl>
                <dl>
                    <dt>담당 구분</dt>
                    <dd>
                        <template v-for="group in partnerYnGroup" key="person.name" >
                            <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput.partnerYn" :value="group.value" />
                        </template>
                    </dd>
                </dl>
                <dl>
                    <dt>교육대상자</dt>
                    <dd>
                        <template v-for="group in lectTrgtGroup" key="person.name" >
                            <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput.lectTrgt" :value="group.value" />
                        </template>
                    </dd>
                </dl>
                <dl>
                    <dt>대표 강의</dt>
                    <dd>
                        <KSACheckBox label="대표 강의 보기" v-model="searchInput.repreLectYn" />
                    </dd>
                </dl>
                <dl>
                    <dt>강의명</dt>
                    <dd>
                        <KSAInput class="text-box" v-model="searchInput.lectName" placeholder="강의명을 입력해주세요." />
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <KSASelect ref="searchDurationGbRef" :options="searchDurationGbGroup" class="select" @selectOption="onSelectSearchDurationGbGroup"/>
                    </dt>
                    <dd class="text-box">
                        <div class="grid">
                            <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                <KSARadioButton class="mr-md" name="searchDurationGb" :label="group.label" v-model="searchInput.searchDurationType" :value="group.value" />
                            </template>
                            <div style="display: inline-block;" v-show="searchInput.searchDurationType !== 'all'">
                                <KSADatepickerTerms
                                        ref="datepickerTermsRef"
                                        :startDate="searchInput.startYmd"
                                        :endDate="searchInput.endYmd"
                                        @update:startDate="(value)=> searchInput.startYmd = value"
                                        @update:endDate="(value)=> searchInput.endYmd = value"
                                />
                            </div>
                        </div>
                    </dd>
                </dl>
                <div class="btn-wrap">
                    <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                    <KSAPrimaryButton text="검색" @click="onClickSearch" />
                </div>
            </div>
        </div> -->
        <div class="list-top">
            <div class="grid">
                <KSASecondaryButton class="gray_button" text="수료증 양식 등록" @click="onClickCreate" />
            </div>
        </div>
        <div class="list-top">
            <p>총 게시물 <span>{{ $number(totalCount) }}</span>개</p>
            <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
        </div>
        <div class="table-form">
            <table class="horizontal">
                <tr>
                    <th width="5%">NO</th>
                    <th width="15%">수료증 이미지</th>
                    <th>수료증명</th>
                    <th width="12%">연결중 강의 수</th>
                    <th width="12%">등록일</th>
                </tr>
                <tr v-for="template in list">
                    <td>{{ template.boardNo }}</td>
                    <td>
                        <KSACertificateTemplatePreview
                            :headSrc="template.frontImageDir"
                            :tailSrc="template.backImageDir"
                            :frontFixedText="template.frontFixedText"
                        />
                    </td>
                    <td @click="onClickDetail(template)" class="link text-left">{{ template.certificateName }}</td>
                    <td>{{ $number(template.linkedLectureCount || 0) }}</td>
                    <td>{{ $yyyymmddHHmmss(template.createDate) }}</td>
                </tr>
                <tr v-if="list.length === 0">
                    <td colspan="5">검색 결과가 없습니다.</td>
                </tr>
            </table>
        </div>
        <Paginate
            v-if="list.length > 0"
            v-model="currentPage"
            :page-count="totalPages"
            :click-handler="onSelectPage"
        />
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    table {
        td {
            .badge {
                margin-top: -16px;
            }
        }
    }

    .text-over {
      min-width: 250px;
    }

</style>
